export default "/images/a84bc938e3e92f0402829d37bc182036.avif";